"use client";

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@pex/ui-web";
import Image from "next/image";

const TESTIMONIALS = [
  {
    quote:
      "\u201CIncredibly personal attention, backed by rigorous research and creative, structured programmes.\u201D",
    name: "Ross Perret",
    avatar:
      "/images/testimonials/Monuments___Art_157_Lincoln_memorial_6b5pk1.webp",
  },
  {
    quote:
      "\u201CProject Exodus literally saved my life and my marriage. Without them and their program I know I wouldn\u2019t be where I am today. It\u2019s been a hard and tough journey but has been so incredibly worth it. For the first time in my life I have a true sense of peace and more importantly, hope.\u201D",
    name: "Duran Barnett",
    avatar: "/images/testimonials/Mountains_311_Mountain_at_sunset_5qk1n.webp",
  },
  {
    quote:
      "\u201CIt immensely informed, trained, sharpened my thinking. Wow.\u201D",
    name: "Warren Elliot",
    avatar: "/images/testimonials/Beaches___Oceans_23_Clam_p4rwm9.avif",
  },
  {
    quote:
      "\u201CGave me a lot of new perspectives on how to approach recovery with the right mindset and skill to work on.\u201D",
    name: "Brenda Jacobs",
    avatar:
      "/images/testimonials/Bridges__Castles___Palaces_665_Brooklyn_Bridge_yph282.webp",
  },
  {
    quote:
      "\u201CHaving worked the material myself on the U-turn program, I am informed in my Recovery.\u201D",
    name: "Priscilla Johnson",
    avatar:
      "/images/testimonials/Natural_Wonders_333_Milford_Sound_odkoen.webp",
  },
  {
    quote:
      "\u201CA professional programme backed by science and scripture and experience was a thought out program that covers expansive and important topics, using the latest cutting edge materials. It was logical and broken up into easy to understand modules.\u201D",
    name: "Rosemary Giralt",
    avatar: "/images/testimonials/Countryside_Scenes_228_Farmhouse_ml5bij.webp",
  },
] as const;

const STAR_KEYS = ["1", "2", "3", "4", "5"] as const;

function StarRating() {
  return (
    <div aria-label="5 out of 5 stars" className="flex gap-0.5" role="img">
      {STAR_KEYS.map((n) => (
        <svg
          aria-hidden="true"
          className="h-5 w-5 fill-amber-400 text-amber-400"
          key={n}
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      ))}
    </div>
  );
}

export function ProgrammesFeedbackCarousel() {
  return (
    <div className="relative">
      {/* Edge fade overlays — pointer-events-none so cards/buttons remain interactive */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute top-0 bottom-16 left-0 z-10 hidden w-32 sm:block"
        style={{
          background:
            "linear-gradient(to right, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.6) 40%, rgba(255,255,255,0) 100%)",
        }}
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute top-0 right-0 bottom-16 z-10 hidden w-32 sm:block"
        style={{
          background:
            "linear-gradient(to left, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.6) 40%, rgba(255,255,255,0) 100%)",
        }}
      />
      <Carousel className="w-full" opts={{ loop: true }}>
        <CarouselContent className="-ml-4">
          {TESTIMONIALS.map((t) => (
            <CarouselItem className="pl-4 md:basis-1/2" key={t.name}>
              <div className="flex h-full flex-col gap-4 rounded-2xl border bg-card p-6 shadow-sm">
                <StarRating />
                <p className="body-base flex-1">{t.quote}</p>
                <div className="flex items-center gap-3">
                  <div className="relative h-9 w-9 shrink-0 overflow-hidden rounded-full">
                    <Image
                      alt=""
                      className="object-cover"
                      fill
                      sizes="36px"
                      src={t.avatar}
                    />
                  </div>
                  <span className="font-semibold text-sm">{t.name}</span>
                </div>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <div className="mt-6 flex items-center gap-2 px-1">
          <CarouselPrevious className="static translate-y-0" />
          <CarouselNext className="static translate-y-0" />
        </div>
      </Carousel>
    </div>
  );
}
